const menu = [
    {
        name: "Shipment",
        icon: "mdi-checkbox-multiple-marked-circle",
        path: "containerQuery"
    },
    {
        name: "Box",
        icon: "mdi-package-variant-closed",
        path: "boxQuery"
    },
    {
        name: "Regular Code File",
        icon: "mdi-file-table-outline",
        path: "regularQuery"
    },
    {
        name: "MixSize Rule",
        icon: "mdi-file-document-box-check-outline",
        path: "itemQuery"
    },
    {
        name: "Scan Record",
        icon: "mdi-history",
        path: "recordQuery"
    },
    // {
    //     name: "生产者",
    //     icon: "mdi-truck-fast",
    //     children: [
    //         {
    //             name: "生产者管理",
    //             icon: "mdi-truck-fast",
    //             path: "producer"
    //         },
    //         {
    //             name: "执行记录",
    //             icon: "mdi-clock-fast",
    //             path: "producerLog"
    //         }
    //     ]
    // },
    // {
    //     name: "消费者",
    //     icon: "mdi-pac-man",
    //     children: [
    //         {
    //             name: "消费者管理",
    //             icon: "mdi-pac-man",
    //             path: "consumer"
    //         },
    //         {
    //             name: "报表",
    //             icon: "mdi-chart-areaspline",
    //             path: "consumerReport"
    //         },
    //         {
    //             name: "执行记录",
    //             icon: "mdi-clock-fast",
    //             path: "consumerLog"
    //         }
    //     ]
    // },
    // {
    //     name: "路由代理",
    //     icon: "mdi-webhook",
    //     children: [
    //         {
    //             name: "站点管理",
    //             icon: "mdi-server",
    //             path: "routing"
    //         },
    //         {
    //             name: "代理管理",
    //             icon: "mdi-webhook",
    //             path: "routingLocation"
    //         },
    //         {
    //             name: "执行记录",
    //             icon: "mdi-clock-fast",
    //             path: "locationLog"
    //         }
    //     ]
    // },
    // {
    //     name: "队列监控",
    //     icon: "mdi-monitor-screenshot",
    //     path: "queue"
    // },
    // {
    //     name: "商家配置",
    //     icon: "mdi-shopping",
    //     path: "mall"
    // },
    // {
    //     name: "系统管理",
    //     icon: "mdi-settings-outline",
    //     children: [
    //         {
    //             name: "系统配置",
    //             icon: "mdi-settings-outline",
    //             path: "threadpool"
    //         },
    //         {
    //             name: "线程池",
    //             icon: "mdi-arch",
    //             path: "threadpool"
    //         },
    //         {
    //             name: "数据归档",
    //             icon: "mdi-package-variant-closed",
    //             path: "database"
    //         }
    //     ]
    // },
    // {
    //     name: "系统监控",
    //     icon: "mdi-ubuntu",
    //     children: [
    //         {
    //             name: "主机监控",
    //             icon: "mdi-server",
    //             path: "user"
    //         },
    //         {
    //             name: "JVM监控",
    //             icon: "mdi-language-java",
    //             path: "role"
    //         },
    //         {
    //             name: "操作日志",
    //             icon: "mdi-history",
    //             path: "menu"
    //         }
    //     ]
    // },
    // {
    //     name: "开发工具",
    //     icon: "mdi-console",
    //     children: [
    //         {
    //             name: "EO管理",
    //             icon: "mdi-alpha-e-circle",
    //             path: "eo"
    //         },
    //         {
    //             name: "VO管理",
    //             icon: "mdi-alpha-v-circle",
    //             path: "vo"
    //         },
    //         {
    //             name: "接口管理",
    //             icon: "mdi-language-java",
    //             path: "rest"
    //         },
    //         {
    //             name: "页面管理",
    //             icon: "mdi-code-tags",
    //             path: "page"
    //         },
    //         {
    //             name: "开发环境",
    //             icon: "mdi-dip-switch",
    //             path: "rest"
    //         },
    //         {
    //             name: "数据源管理",
    //             icon: "mdi-database",
    //             path: "menu"
    //         }
    //     ]
    // },
]

export default menu;